import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import {_throw} from 'rxjs/observable/throw';
import { of } from 'rxjs/observable/of';
import {map, catchError, retryWhen, concatMap, delay} from 'rxjs/operators';

import {ApiService} from './api.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class NoopInterceptor implements HttpInterceptor {
    constructor(private api: ApiService) {}
    intercept(req: HttpRequest<any>, next: HttpHandler):
        Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            map(event => {
                if( event instanceof HttpResponse ) {
                    let foundPosts = event.headers && event.headers.get('X-WP-Total') ? parseInt(event.headers.get('X-WP-Total')) : 0;
                    this.api.foundPosts = foundPosts;
                }
                return event;
            }),
            // retry a 504 in 5 second intervals up to 10 times
            retryWhen(errors => 
                errors.pipe(
                    concatMap((res, index) => {
                        if( res.status !== 504 || index > 10 ) {
                            return _throw(res);
                        }
                        return of(errors).pipe(delay(5000));
                    })
                )
            ),
            catchError(error => {
                error.response = req;
                return _throw(error);
            })
        );
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/shared/api.interceptor.ts